import { render, staticRenderFns } from "./ProjectPlantingPurpose.vue?vue&type=template&id=913524e4"
import script from "./ProjectPlantingPurpose.vue?vue&type=script&lang=js"
export * from "./ProjectPlantingPurpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports